import { render, staticRenderFns } from "./SubDropdown.vue?vue&type=template&id=62b831ac&scoped=true&"
import script from "./SubDropdown.vue?vue&type=script&lang=js&"
export * from "./SubDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b831ac",
  null
  
)

export default component.exports